import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
export function Guarantee() {
  return <Section className="bg-brand-cream" data-id="element-108">
      <Reveal className="mx-auto max-w-2xl rounded-3xl border-2 border-brand-teal/25 bg-white p-6 text-center shadow-sm sm:p-8" data-id="element-109">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-brand-teal/15" data-id="element-110">
          <ShieldCheckIcon className="h-9 w-9 text-brand-teal" data-id="element-111" />
        </div>
        <h2 className="font-display text-2xl font-extrabold text-brand-purpleDark sm:text-3xl" data-id="element-112">
          Garantía de Satisfacción de 7 Días
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm font-semibold text-brand-purpleDark/75 sm:text-base" data-id="element-113">
          Queremos que pruebes el Sistema Corrige Evaluaciones en 30 minutos con
          total tranquilidad. Si durante los primeros 7 días consideras que el
          contenido no cumple con tus expectativas, solo escríbenos y
          procesaremos tu reembolso.
        </p>
        <p className="mt-4 font-display text-base font-extrabold text-brand-teal" data-id="element-114">
          Tu compra está completamente protegida.
        </p>
      </Reveal>
    </Section>;
}